var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionResetToDefaultDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_reset_to_default_dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12 18C9.38756 18 7.16508 16.3304 6.34141 14H4.25204C5.14012 17.4505 8.27232 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.79086 4 7.79086 4.89543 6.34315 6.34315L4 4V11H11L7.75736 7.75736C8.84315 6.67157 10.3431 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionResetToDefaultDark);
export default __webpack_public_path__ + "static/media/ic_action_reset_to_default_dark.90df3c5c5cf1a29549604f5669606c5f.svg";
export { ForwardRef as ReactComponent };